import {
  USER_ROLE_ADMIN,
  USER_ROLE_BACKOFFICE,
  USER_ROLE_REGULAR,
} from "../constants";

export const ROLE_OPTIONS = [
  USER_ROLE_REGULAR,
  USER_ROLE_BACKOFFICE,
  USER_ROLE_ADMIN,
].map((role) => ({ label: role, value: role }));

export function extendUserWithRole(user) {
  const staffRole = user.admin ? USER_ROLE_ADMIN : USER_ROLE_BACKOFFICE;

  return {
    ...user,
    role: user.backoffice ? staffRole : USER_ROLE_REGULAR,
  };
}

export function hasBackofficeAccess(user) {
  return [USER_ROLE_ADMIN, USER_ROLE_BACKOFFICE].includes(user.role);
}

export function hasAdminAccess(user) {
  return user.role === USER_ROLE_ADMIN;
}
